var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCatCardArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9V7ZM29.0984 8.70711C29.4889 8.31658 29.4889 7.68342 29.0984 7.29289L22.7344 0.928932C22.3439 0.538408 21.7108 0.538408 21.3202 0.928932C20.9297 1.31946 20.9297 1.95262 21.3202 2.34315L26.9771 8L21.3202 13.6569C20.9297 14.0474 20.9297 14.6805 21.3202 15.0711C21.7108 15.4616 22.3439 15.4616 22.7344 15.0711L29.0984 8.70711ZM1 9H28.3913V7H1V9Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCatCardArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cat_card_arrow.21527401.svg";
export { ForwardRef as ReactComponent };